// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".placeholder-clr{color:var(--kw-select-border-color)}", "",{"version":3,"sources":["webpack://./src/components/FormFields/ScrollableSelect.vue"],"names":[],"mappings":"AACA,iBACE,mCAAF","sourcesContent":["\r\n.placeholder-clr {\r\n  color: var(--kw-select-border-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
